const objectsNameTypes = {
    app: 'חודשAI',
    albert: 'אלברט',
    weekContent: "תוכן השבוע",
    championships: "תחרויות",
    bina: "בינה",
    gemini: "גמיני",
    strengths: "הכוחות שבדרך",
    aiIntro: "מבוא ל״מ- לומדה",
    learningEvents: "אירועי למידה",
    games: "משחקים",
    curatorship: "גלריה"
}

export default objectsNameTypes;